import {
  ionAddCircle,
  ionAddCircleOutline,
  ionAddOutline,
  ionAlbumsOutline,
  ionAlertCircleOutline,
  ionApertureOutline,
  ionArrowBackOutline,
  ionArrowDownSharp,
  ionArrowForwardOutline,
  ionArrowUp,
  ionAttach,
  ionBanOutline,
  ionBasketOutline,
  ionBusinessOutline,
  ionCalendarClearOutline,
  ionCalendarOutline,
  ionCallOutline,
  ionCamera,
  ionCameraOutline,
  ionCaretBackOutline,
  ionCaretForwardOutline,
  ionCheckmarkCircle,
  ionCheckmarkCircleOutline,
  ionCheckmarkDoneCircleOutline,
  ionCheckmarkOutline,
  ionChevronBack,
  ionChevronBackOutline,
  ionChevronDown,
  ionChevronDownOutline,
  ionChevronForward,
  ionChevronForwardCircle,
  ionChevronForwardCircleOutline,
  ionChevronForwardOutline,
  ionChevronUp,
  ionChevronUpOutline,
  ionClipboardOutline,
  ionClose,
  ionCloseCircleOutline,
  ionCloseOutline,
  ionCloseSharp,
  ionCodeWorkingOutline,
  ionConstructOutline,
  ionCopyOutline,
  ionCreate,
  ionCubeOutline,
  ionDesktopOutline,
  ionDocumentOutline,
  ionDownload,
  ionDownloadOutline,
  ionEllipsisVerticalOutline,
  ionExitOutline,
  ionEyeOff,
  ionEyeOutline,
  ionFilterOutline,
  ionFingerPrintOutline,
  ionFunnelOutline,
  ionGiftOutline,
  ionGitCommit,
  ionGitNetworkOutline,
  ionHeadsetOutline,
  ionHomeOutline,
  ionImageOutline,
  ionInformationCircleOutline,
  ionKeyOutline,
  ionLayersOutline,
  ionLink,
  ionPersonCircleOutline,
  ionPersonOutline,
  ionLogoFacebook,
  ionLogoInstagram,
  ionLogoTwitter,
  ionMedicalOutline,
  ionMic,
  ionMicOff,
  ionMicOutline,
  ionNotifications,
  ionNotificationsOutline,
  ionShieldCheckmarkOutline,
  ionOpen,
  ionOpenOutline,
  ionPauseCircleOutline,
  ionPawOutline,
  ionPencilOutline,
  ionPeopleOutline,
  ionPlayCircleOutline,
  ionRefresh,
  ionRemoveCircleOutline,
  ionRepeatOutline,
  ionSearchOutline,
  ionSend,
  ionSettingsOutline,
  ionSyncCircleOutline,
  ionTimeOutline,
  ionTrashBinOutline,
  ionVideocamOffOutline,
  ionVideocamOutline,
  ionWarning,
  ionWarningOutline,
} from '@ng-icons/ionicons';
import {
  AlertCircle,
  AlertTriangle,
  ArrowUpCircle,
  ArrowUpRightFromCircle,
  Asterisk,
  BadgeCheck,
  Bell,
  Calendar,
  CalendarCheck,
  Cat,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronsRight,
  ChevronsUpDown,
  ChevronUp,
  CircleAlert,
  Clipboard,
  Clock,
  Cog,
  Copy,
  Crosshair,
  Dog,
  Expand,
  Eye,
  EyeOff,
  Files,
  FileSpreadsheet,
  FileText,
  FileUser,
  Filter,
  Flame,
  FlaskRound,
  Fullscreen,
  GitCommit,
  HelpCircle,
  Home,
  History,
  Image,
  ImagePlus,
  Info,
  Link,
  Loader2,
  LogOut,
  Menu,
  MessagesSquare,
  MoreVertical,
  Mic,
  MicOff,
  Minus,
  MinusCircle,
  Monitor,
  MonitorDown,
  MoveRight,
  Network,
  NotebookPen,
  Pen,
  Pencil,
  Phone,
  PhoneOff,
  PictureInPicture2,
  PillBottle,
  Pin,
  Plus,
  PlusCircle,
  Pointer,
  Puzzle,
  RefreshCcw,
  RefreshCw,
  Replace,
  ReplaceAll,
  ScreenShare,
  Search,
  Server,
  Share2,
  Smartphone,
  Settings,
  SlidersHorizontal,
  SquarePen,
  Star,
  Tablets,
  Text,
  ThumbsDown,
  ThumbsUp,
  Trash,
  Trash2,
  User,
  Video,
  VideoOff,
  Volume2,
  VolumeX,
  X,
} from 'lucide-angular';

export const ICONS = {
  ArrowUpRightFromCircle,
  RefreshCcw,
  RefreshCw,
  X,
  PlusCircle,
  Dog,
  Trash2,
  Trash,
  MinusCircle,
  Cat,
  Copy,
  Info,
  Pointer,
  Server,
  SlidersHorizontal,
  Text,
  GitCommit,
  Replace,
  ReplaceAll,
  Image,
  Video,
  Crosshair,
  Monitor,
  MonitorDown,
  ChevronsRight,
  Check,
  ChevronsUpDown,
  Puzzle,
  Pen,
  SquarePen,
  User,
  UserIcon: User,
  VideoIcon: Video,
  PhoneIcon: Phone,
  Home,
  History,
  Link,
  Network,
  Menu,
  Settings,
  ChevronRight,
  PictureInPicture2,
  VideoOff,
  Mic,
  MicOff,
  ScreenShare,
  PhoneOff,
  Phone,
  Expand,
  Fullscreen,
  ChevronLeft,
  Plus,
  ImagePlus,
  ChevronDown,
  Calendar,
  CalendarCheck,
  Clock,
  Pencil,
  FlaskRound,
  Eye,
  Star,
  Flame,
  Minus,
  EyeOff,
  AlertCircle,
  HelpCircle,
  Filter,
  AlertTriangle,
  MessagesSquare,
  Pin,
  Loader2,
  ArrowUpCircle,
  ThumbsUp,
  ThumbsDown,
  ChevronUp,
  Asterisk,
  PillBottle,
  Clipboard,
  BadgeCheck,
  Bell,
  Cog,
  FileUser,
  Tablets,
  Search,
  Share2,
  Smartphone,
  NotebookPen,
  Files,
  FileText,
  LogOut,
  FileSpreadsheet,
  MoveRight,
  MoreVertical,
  CircleAlert,
  VolumeX,
  Volume2,
};

export const NGICONS = {
  ionEllipsisVerticalOutline,
  ionCheckmarkCircle,
  ionEyeOutline,
  ionEyeOff,
  ionArrowDownSharp,
  ionTimeOutline,
  ionOpen,
  ionFilterOutline,
  ionSearchOutline,
  ionFingerPrintOutline,
  ionHomeOutline,
  ionCalendarClearOutline,
  ionVideocamOutline,
  ionGitNetworkOutline,
  ionPeopleOutline,
  ionAlbumsOutline,
  ionClipboardOutline,
  ionTrashBinOutline,
  ionAddOutline,
  ionDocumentOutline,
  ionArrowBackOutline,
  ionMedicalOutline,
  ionCloseOutline,
  ionFunnelOutline,
  ionCaretForwardOutline,
  ionCaretBackOutline,
  ionChevronBackOutline,
  ionChevronForwardOutline,
  ionChevronDownOutline,
  ionChevronUpOutline,
  ionCallOutline,
  ionConstructOutline,
  ionRemoveCircleOutline,
  ionAddCircleOutline,
  ionLink,
  ionAttach,
  ionOpenOutline,
  ionBasketOutline,
  ionCodeWorkingOutline,
  ionMic,
  ionSyncCircleOutline,
  ionChevronDown,
  ionChevronUp,
  ionRefresh,
  ionCheckmarkCircleOutline,
  ionCloseCircleOutline,
  ionMicOff,
  ionApertureOutline,
  ionImageOutline,
  ionHeadsetOutline,
  ionRepeatOutline,
  ionCameraOutline,
  ionDesktopOutline,
  ionCopyOutline,
  ionMicOutline,
  ionSettingsOutline,
  ionArrowForwardOutline,
  ionGitCommit,
  ionVideocamOffOutline,
  ionExitOutline,
  ionLogoFacebook,
  ionLogoInstagram,
  ionLogoTwitter,
  ionChevronForwardCircleOutline,
  ionChevronForwardCircle,
  ionChevronForward,
  ionChevronBack,
  ionArrowUp,
  ionPawOutline,
  ionInformationCircleOutline,
  ionKeyOutline,
  ionPersonCircleOutline,
  ionClose,
  ionSend,
  ionCamera,
  ionNotifications,
  ionNotificationsOutline,
  ionCloseSharp,
  ionDownloadOutline,
  ionCalendarOutline,
  ionAlertCircleOutline,
  ionAddCircle,
  ionPlayCircleOutline,
  ionPauseCircleOutline,
  ionPencilOutline,
  ionCheckmarkDoneCircleOutline,
  ionDownload,
  ionWarning,
  ionWarningOutline,
  ionCreate,
  ionShieldCheckmarkOutline,
  ionPersonOutline,
  ionCubeOutline,
  ionBusinessOutline,
  ionGiftOutline,
  ionLayersOutline,
  ionBanOutline,
  ionCheckmarkOutline,
};
